export default __webpack_public_path__ + "static/bluepiercingdust-a3cf93ea794f848aef87ae2bdcb79d06.png";